<template>
  <div class="esh-theme">
    <h1>THEME - ESH</h1>
    <br />
    <a href="/">Home</a>
    <br />
    <v-toolbar height="22">
      <v-toolbar-items>
        <v-btn to="/">Start Page</v-btn>
        <v-btn to="/ui-esh">THEME - ESH</v-btn>
        <v-btn to="/">Start Page</v-btn>
        <v-btn to="/">Start Page</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <br />
    <h1>Текст</h1>
    <h2>Текст</h2>
    <h3>Текст</h3>
    <h4>Текст</h4>
    <h5>Текст</h5>
    <h6>Текст</h6>
    <p>строка</p>
    <table>
      <tr>
        <td>
          <v-btn class="">Показать</v-btn>
        </td>
        <td>
          <v-btn disabled>Текст</v-btn>
        </td>
        <td>
          <v-btn
            class=""
            color="primary"
          >Текст</v-btn>
        </td>
        <td>
          <v-btn
            class=""
            color="error"
          >Текст</v-btn>
        </td>
      </tr>
      <tr>
        <td>
          <v-checkbox
            v-model="valueCheck"
            :label="`Checkbox 1: `"
          ></v-checkbox>
        </td>
        <td>
          <v-checkbox
            v-model="valueCheck"
            disabled
            :label="`Checkbox 1: `"
          ></v-checkbox>
        </td>
        <td>
          <v-checkbox
            v-model="valueCheck"
            readonly
            :label="`Checkbox 1: `"
          ></v-checkbox>
        </td>
        <td>
          <v-checkbox
            v-model="valueCheck"
            :label="`Checkbox 1: `"
          ></v-checkbox>
        </td>
      </tr>
      <tr>
        <td>
          <v-radio
            :label="`Radio 1`"
            :value="true"
          ></v-radio>
        </td>
        <td>
          <v-radio
            disabled
            :label="`Radio 1`"
            :value="true"
          ></v-radio>
        </td>
        <td></td>
        <td></td>
      </tr>
      <tr>
        <td>
          <v-switch
            v-model="valueCheck"
            :label="`Switch 1: `"
          ></v-switch>
        </td>
        <td>
          <v-switch
            v-model="valueCheck"
            disabled
            :label="`Switch 1: `"
          ></v-switch>
        </td>
        <td>
          <v-switch
            v-model="valueCheck"
            error
            :label="`Switch 1: `"
          ></v-switch>
        </td>
        <td>
          <v-switch
            v-model="valueCheck"
            :label="`Switch 1: `"
          ></v-switch>
        </td>
      </tr>
      <tr>
        <td>
          <v-text-field
            label="Поиск по ФИО"
            placeholder="Поиск по ФИО"
          >
          </v-text-field>
        </td>
        <td>
          <v-text-field
            label="labellabellabellabel"
            disabled
          ></v-text-field>
        </td>
        <td>
          <v-text-field
            label="labellabellabellabel"
            error
          ></v-text-field>
        </td>
        <td>
          <v-text-field
            label="Regular"
            placeholder="Placeholder"
          ></v-text-field>
        </td>
      </tr>
      <tr>
        <td>
          <v-select
            :items="items"
            label="Тип карты"
            dense
          ></v-select>
        </td>
        <td>
          <v-select
            :items="items"
            disabled
            label="SELECT"
            dense
          ></v-select>
        </td>
        <td>
          <v-select
            :items="items"
            error
            label="SELECT"
            dense
          ></v-select>
        </td>
        <td>
          <v-select
            :items="items"
            color="error"
            label="SELECT"
            dense
          ></v-select>
        </td>
      </tr>
      <tr>
        <td>
          <DatePicker
            :labelText="'Дата'"
            :dateValue.sync="date1"
            @changeDate="changeDateHandler"
          />
        </td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
      <tr>
        <td>
          <RangeDatePicker
            :startDate.sync="dateStart"
            :endDate.sync="dateEnd"
            @changeRange="changeRangeHandler"
          />
        </td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
    </table>

    <Table
      :headers="headers"
      :items="desserts"
      hide-default-footer
      class="elevation-1"/>
  </div>
</template>

<script>
import { DatePicker, RangeDatePicker, Table } from '@/components/common'
export default {
	name: 'ui',
	components: {
		DatePicker,
    RangeDatePicker,
    Table
	},
	data: () => ({
		valueCheck: false,
		items: ['Foooooooooooooooooooooooooo', 'Bar', 'Fizz', 'Buzz'],
		date1: new Date().toISOString().substr(0, 10),
		dateStart: new Date().toISOString().substr(0, 10),
		dateEnd: new Date().toISOString().substr(0, 10),
		headers: [
			{
				text: 'Dessert (100g serving)',
				align: 'left',
				sortable: false,
				value: 'name'
			},
			{ text: 'Calories', value: 'calories' },
			{ text: 'Fat (g)', value: 'fat' },
			{ text: 'Carbs (g)', value: 'carbs' },
			{ text: 'Protein (g)', value: 'protein' },
			{ text: 'Iron (%)', value: 'iron' }
		],
		desserts: [
			{
				name: 'Frozen Yogurt',
				calories: 159,
				fat: 6.0,
				carbs: 24,
				protein: 4.0,
				iron: '1%'
			},
			{
				name: 'Ice cream sandwich',
				calories: 237,
				fat: 9.0,
				carbs: 37,
				protein: 4.3,
				iron: '1%'
			},
			{
				name: 'Eclair',
				calories: 262,
				fat: 16.0,
				carbs: 23,
				protein: 6.0,
				iron: '7%'
			},
			{
				name: 'Cupcake',
				calories: 305,
				fat: 3.7,
				carbs: 67,
				protein: 4.3,
				iron: '8%'
			},
			{
				name: 'Gingerbread',
				calories: 356,
				fat: 16.0,
				carbs: 49,
				protein: 3.9,
				iron: '16%'
			},
			{
				name: 'Jelly bean',
				calories: 375,
				fat: 0.0,
				carbs: 94,
				protein: 0.0,
				iron: '0%'
			},
			{
				name: 'Lollipop',
				calories: 392,
				fat: 0.2,
				carbs: 98,
				protein: 0,
				iron: '2%'
			},
			{
				name: 'Honeycomb',
				calories: 408,
				fat: 3.2,
				carbs: 87,
				protein: 6.5,
				iron: '45%'
			},
			{
				name: 'Donut',
				calories: 452,
				fat: 25.0,
				carbs: 51,
				protein: 4.9,
				iron: '22%'
			},
			{
				name: 'KitKat',
				calories: 518,
				fat: 26.0,
				carbs: 65,
				protein: 7,
				iron: '6%'
			}
		]
	}),
	methods: {
		changeDateHandler(value) {
			console.log(['Date changed', value])
		},
		changeRangeHandler(payload) {
			console.log('LOG: changeDate -> payload name', payload.name)
			console.log('LOG: changeDate -> payload value', payload.value)
		}
	}
}
</script>
